'use client';
import Deposit from '@launchpad/components/pages/Sale/ui/Deposit/Deposit';

import Allocation from './ui/Allocation/Allocation';
import ProjectInfo from './ui/ProjectInfo/ProjectInfo';

const Page = () => {
  return (
    <main className="main-container py-16 min-h-[calc(100vh_-_150px)]">
      <ProjectInfo />
      <section className="md:flex justify-between gap-4">
        <div className="flex flex-col gap-4 md:max-w-[390px] md:min-w-[330px] w-full pb-4 md:pb-0">
          <Allocation />
        </div>
        <div className="max-w-[750px] w-full">
          <Deposit />
        </div>
      </section>
    </main>
  );
};

export default Page;
